import {
  SELLERPOINTLIST_FETCHITEMS_LOAD,
  SELLERPOINTLIST_FETCHITEMS_SUCCEED,
  SELLERPOINTLIST_FETCHITEMS_FAIL,
  SELLERPOINTLIST_CHANGETABLE_CHANGE,
  SELLERPOINTLIST_SEARCHTABLE_EDIT,
  SELLERPOINTLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERPOINTLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case SELLERPOINTLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case SELLERPOINTLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case SELLERPOINTLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case SELLERPOINTLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case SELLERPOINTLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerPointList.js